import React from 'react'
import { NumberInput } from '../../../../Components/Input/NumberInput'
import { Currencies } from '../../../../Constants/Currencies'
import {
  Dropdown,
  MessageBar,
  MessageBarType,
  Stack,
} from 'office-ui-fabric-react'

export function PriceFloorInput({
  priceFloor,
  currency,
  setPriceFloor,
  setCurrency,
  errorMessage,
  disabled,
}: {
  priceFloor: number
  currency: Currencies
  setPriceFloor: (priceFloor: number) => void
  setCurrency: (currency: Currencies) => void
  errorMessage: string
  disabled: boolean
}) {
  return (
    <>
      <Stack horizontal gap={16}>
        <NumberInput
          label="Minimum Price Floor"
          errorMessage={errorMessage}
          value={priceFloor}
          style={{
            flexGrow: 1,
            maxWidth: 'calc(50% - 8px)',
          }}
          onChange={(value?: number) =>
            setPriceFloor(value === undefined ? 0 : value!)
          }
          disabled={disabled}
          required
          min={0}
          max={1e9}
          precision={5}
        />
        <Dropdown
          label="Minimum Price Floor Currency"
          selectedKey={currency}
          onChange={(event, value?) => {
            if (!value) {
              return
            }
            const newCurrency = value.key as Currencies
            if (currency === newCurrency) {
              return
            }
            setCurrency(newCurrency)
          }}
          required={true}
          options={Object.keys(Currencies).map((currency) => ({
            key: currency,
            text: currency,
          }))}
          calloutProps={{ calloutMaxHeight: 300 }}
          disabled={disabled}
          styles={{
            root: {
              flexGrow: 1,
              position: 'relative',
            },
          }}
        />
      </Stack>
      <MessageBar messageBarType={MessageBarType.info} isMultiline={true}>
        Sets the minimum allowed floor for the auction in which the campaign is
        run. Important: this is not the same as setting an individual price
        floor. A different campaign with a higher minimum allowed price floor
        running in the same auction will also increase the price floor of this
        one.
      </MessageBar>
    </>
  )
}
